import { SEVERITY_ORDER, STATE_TO_BUCKET, STATUS_BUCKET } from '../constants';

/**
 * Provider-level status is an AGGREGATE of its instances (CT-4197).
 *
 * Lives in the mock service/util layer ONLY — never called from components.
 * TODO(CT-3904 / backend): the server will own this; the UI reads `provider.status`
 * and the breakdown fields.
 *
 * Precedence (CT-4195 `SEVERITY_ORDER`, highest severity wins):
 *   1. worst red state present  (auth_failed → auth_expired → provider_down)
 *   2. else worst amber state   (rate_limited → schema_drift → needs_mapping → auth_expiring)
 *   3. else all working         → working
 *   4. else all disconnected/unknown → disconnected
 *   5. else no instances        → not_connected (no pill, Connect CTA)
 *
 * @param {Array<{status: string}>} instances
 * @returns {{ status: string, working_count: number, needs_attention_count: number }}
 */
export const aggregateProviderStatus = (instances = []) => {
  if (!Array.isArray(instances) || instances.length === 0) {
    return { status: 'not_connected', working_count: 0, needs_attention_count: 0 };
  }

  const statuses = instances.map((i) => i.status);

  const working_count = statuses.filter((s) => STATE_TO_BUCKET[s] === STATUS_BUCKET.WORKING).length;
  const needs_attention_count = statuses.filter(
    (s) => STATE_TO_BUCKET[s] === STATUS_BUCKET.NEEDS_ATTENTION,
  ).length;

  // Worst attention state present, by SEVERITY_ORDER (red states precede amber).
  const worstAttention = SEVERITY_ORDER.find((sev) => statuses.includes(sev));
  if (worstAttention) {
    return { status: worstAttention, working_count, needs_attention_count };
  }

  if (working_count > 0) {
    return { status: 'working', working_count, needs_attention_count };
  }

  // Everything left is disconnected/unknown.
  return { status: 'disconnected', working_count, needs_attention_count };
};
